import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { ChooseTableComponent } from '../choose-table/choose-table.component';
//import { OrderCommentComponent } from '../order-comment/order-comment.component';

@Component({
  selector: 'app-order-type',
  templateUrl: './order-type.component.html',
  styleUrls: ['./order-type.component.css']
})
export class OrderTypeComponent implements OnInit {

  model = { 'service_method': '', 'serv_table_id': '', 'table_number': '' };

  tableDialogRef: MatDialogRef<ChooseTableComponent>;
  //commentDialogRef: MatDialogRef<OrderCommentComponent>;

  Success_Msg; 
  Error_Msg; 
  Order_Error_Msg;
  Table_Error_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<OrderTypeComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Order_Error_Msg').subscribe((res: string) => {
      this.Order_Error_Msg = res;
    });

    translate.get('Table_Error_Msg').subscribe((res: string) => {
      this.Table_Error_Msg = res;
    });
  }

  ngOnInit() {
    if (this.dialog_data['service_method'] != undefined)
      this.model.service_method = this.dialog_data['service_method'];

    if (this.dialog_data['serv_table_id'] != undefined)
      this.model.serv_table_id = this.dialog_data['serv_table_id'];
  }


  choose_table() {
    this.tableDialogRef = this.dialog.open(ChooseTableComponent, {
      hasBackdrop: false,
      data: { 'dialog_type': 'select_table', 'serv_table_id': this.model.serv_table_id }
    });
    this.tableDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result['serv_table_id'] != undefined) {
          this.model.serv_table_id = result['serv_table_id'];
          this.model.table_number = result['table_number'];

          this.save();
        }
          
      });
  }

  // order_comment() {
  //   this.commentDialogRef = this.dialog.open(OrderCommentComponent, {
  //     hasBackdrop: false,
  //     //data: this.dialog_data
  //   });
  //   this.commentDialogRef
  //     .afterClosed()
  //     .subscribe(result => {

  //     });
  // }

  // count(type) {

  //   if (type == 'add')
  //     this.model['count'] = String(Number(this.model['count']) + 1);

  //   else if (type == 'subtract' && Number(this.model['count']) > 0)
  //     this.model['count'] = String(Number(this.model['count']) - 1);
  // }

  save() {
    if (this.model.service_method == '') {
      alert(this.Order_Error_Msg);
      return;
    }
    
    if (this.model.service_method == 'dine_in' && this.model.serv_table_id == '') {
      alert(this.Table_Error_Msg);
      return;
    }

    this.dialog_data['service_method'] = this.model.service_method;
    this.dialog_data['serv_table_id'] = (this.model['service_method'] == 'dine_in' ? this.model.serv_table_id : '');
    this.dialog_data['table_number'] = (this.model['service_method'] == 'dine_in' ? this.model.table_number : '');
    this.dialogRef.close(this.dialog_data);
  }

  // cancel() {
  //   this.dialogRef.close(this.dialog_data);
  // }

}
